import "./datatable.scss";
import { DataGrid } from "@mui/x-data-grid";
import { roomsColumns, roomsRows } from "../../datatablesource";  
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { collection, getDocs, doc, deleteDoc, updateDoc } from "firebase/firestore";
import {db} from "../../firebase"

const DatatableRooms = () => {
  const [data, setData] = useState([]);
  const [toggler, setToggler] = useState(true)

  const handleToggler= ()=>{
    toggler? setToggler(false) && data.status(false) : setToggler(true) && data.status(true)

    
    console.log("changed")
  }


  //fetching rooms data
  useEffect(() => {
    const fetchData = async () =>{
      let rooms = []
      try {
        const querySnapshot = await getDocs(collection(db, "rooms"));
        querySnapshot.forEach((doc) => {
        rooms.push({id: doc.id, ...doc.data()})
      });
      setData(rooms)
      } catch (err) {
        console.log(err)
      }
      
    }
    fetchData()
  }, [])
  console.log(data)

  const handleDelete = async(id) => {
    try {
      await deleteDoc(doc(db, "rooms", id));
      setData(data.filter((item) => item.id !== id));
    } catch (err) {
      console.log(err)
    }
  };

  const handleEdit = async (id)=>{
    try {
      await updateDoc(doc(db, "rooms", id), {
        data:true
      });
    } catch (err) {
      console.log(err)
    }
  }

  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            <Link to="/rooms/edit" style={{ textDecoration: "none" }}>
              <div 
                className="viewButton"
                onClick={()=>handleEdit(params.row.id)}
                >Edit</div>
            </Link>
            <div
              className="deleteButton"
              onClick={() => handleDelete(params.row.id)}
            >
              Delete
            </div>
          </div>
        );
      },
    },
  ];

  const statusParam = [
    {
      field: "status",
      headerName: "Disable/Enable",
      width: 160,
      renderCell: () => {
        return (
          <div className="">
            <label htmlFor ="toggle-switch">
                <input 
                  defaultChecked
                  type="checkbox" 
                  id="toggle-switch" 
                  className="cursor-pointer rounded-full checked:bg-green-500  h-5 w-10 appearance-none bg-red-500 bg-opacity-20 transition duration-200 relative "
                  onClick={handleToggler}
                  {...toggler? data.status=false : data.status=true} 
                  />
                  
            </label>
          </div>
        );
      },
    },
  ]
  return (
    <div className="datatable">
      <div className="datatableTitle">
        Rooms list
        <Link to="/rooms/newroom" className="link">
          Add New
        </Link>
      </div>
      <DataGrid
        className="datagrid"
        rows={data.concat()}
        columns={roomsColumns.concat(statusParam, actionColumn)}
        pageSize={9}
        rowsPerPageOptions={[9]}
        status={data.status}
      />
    </div>
  );
};

export default DatatableRooms;
